import { css } from '@emotion/react';
import { SchedulingType } from '@weave/schema-gen-ts/dist/schemas/ai-settings/v1/ai_settings.pb';
import { ContentLoader } from '@frontend/design-system';
import { SchedulingInstructionAccordionForm } from './scheduling-instruction-accordion-form';

type Props = {
  locationId: string;
  mode: SchedulingType;
  onChange: (locationId: string, newMode: SchedulingType) => void;
  isLoading?: boolean;
};

export const SingleLocationSchedulingInstruction = ({ locationId, mode, isLoading, onChange }: Props) => {
  return (
    <div css={styles.container}>
      <ContentLoader show={isLoading} />
      <SchedulingInstructionAccordionForm
        locationIds={[locationId]}
        mode={mode}
        onChange={(newMode) => onChange(locationId, newMode)}
      />
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: var(--fabric-space-gap-lg);
    padding: var(--fabric-space-gap-lg);
    background-color: var(--fabric-color-surface-default);
    box-shadow: var(--fabric-card-shadow);
    border-radius: var(--fabric-radius-md);
    max-width: 700px;
  `,
};
